import Dialog from '../../ui/Dialog';
import ProductDetail from './index';
import './ProductModal.css';

function ProductModal({
  isOpen,
  onClose,
  product,
  lockedItemId,
  onAddFreeItem,
  coupon,
  onAddBXGYItem,
}) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      className="product-modal-dialog"
      contentClassName="product-modal-content"
      motionInitial={{ transform: 'translateY(100%)' }}
      motionAnimate={{
        transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
      }}
    >
      <div className="relative bg-white">
        <ProductDetail
          product={product}
          isModal={true}
          onClose={onClose}
          lockedItemId={lockedItemId}
          onAddFreeItem={onAddFreeItem}
          coupon={coupon}
          onAddBXGYItem={onAddBXGYItem}
        />
      </div>
    </Dialog>
  );
}

export default ProductModal;
